import templateUrl from '../bicycle-pedestrian-template.html';
import findIndex from 'lodash/findIndex';

export const bicyclePedestrianMainComponent = {
	templateUrl,

	//binding title, details and onSubmit function
	bindings: {
		pageTitle: '@',
		details: '<',
        onSubmit: '&',
        county: '<',
		disableButtons: '<',
		parentSlug: '@'
	},

	//controller for BicyclePedestrianMainComponent
	controller: class BicyclePedestrianMainComponent {
		constructor($state, ModalService, CompareObjectService, Constants) {
			'ngInject';

			this.$state = $state;
			this.modalService = ModalService;
			this.compareObjectService = CompareObjectService;
			this.constants = Constants;
		}

		$onInit() {
			this.details = this.details || {
				serviceArea: [],
				name: "",
				url: "",
				image: "",
				description: ""
			};
			
			this.defaultCounties = this.details.serviceArea;
			this.saveData = angular.copy(this.details);
		}

		onUpload({details: {uuid}}) {
			this.details.image = uuid;
		}

		//category select function for autocomplete
		onSelectItem(value) {
			const index = findIndex(this.details.serviceArea, ({ id }) => id === value.id);
			if (index === -1) {
				value.status = this.constants.STATUS.ADD;
				this.details.serviceArea.push(value);
			} else {
				this.details.serviceArea[index].status = -1;
			}
		}

		//category remove function for autocomplete
		onRemoveTag(value) {
			const index = findIndex(this.details.serviceArea, ({ name }) => name === value);
			if (this.details.serviceArea[index].status !== 0) {
				this.details.serviceArea[index].status = this.constants.STATUS.DELETE;
			}
		}

		onRemoveLogo() {
			this.details.image = "";
		}

		//on cancel function
		onCancel() {
			const _details = angular.copy(this.details);
			const isUpdated = this.compareObjectService.deepCompareObjectHasChanged(this.saveData, _details, true);
			
			if(isUpdated) {
				this.modalService.open({
					details: {
						bodyMessage: 'Changes done will be reverted. Continue?'
					},
	
					buttons: [
						{
							name: 'No'
						},
						{
							name: 'Yes',
							isPrimary: true,
							action: onSubmit.bind(this)
						}
					]
				});
			} else {
				this._redirectToParentState(this.parentSlug);
			}

			function onSubmit() {
				this._redirectToParentState(this.parentSlug);
			}
		}

		_onSubmit() {
			this.onSubmit({
				details: this.details
			});
		}

		_redirectToParentState(slug) {
            this.$state.go('app.dashboard.DynamicMenus', {
                url: slug
            });
        }
	}
}


// WEBPACK FOOTER //
// ./src/app/components/transportation-alternative/bicycle-pedestrian/bicycle-pedestrian-main/bicycle-pedestrian-main.component.js